export default __webpack_public_path__ + "static/media/SDCAR2.462f0ff0.gif";